/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Guestlist_ApprovedInputs */

const en_scene_guestlist_approved = /** @type {(inputs: Scene_Guestlist_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approved`)
};

/**
* | output |
* | --- |
* | "Approved" |
*
* @param {Scene_Guestlist_ApprovedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_guestlist_approved = /** @type {((inputs?: Scene_Guestlist_ApprovedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Guestlist_ApprovedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_guestlist_approved(inputs)
});